import React from "react";

function SkillItem({ title }) {
  return (
    <li>
      <span>
        <img
          alt="arrow"
          src="https://tokyo-nextjs.vercel.app/img/svg/rightarrow.svg"
          width="10"
          height="10"
          decoding="async"
          data-nimg="1"
          className="svg"
          loading="lazy"
        />
        {title}
      </span>
    </li>
  );
}

export default SkillItem;
